import bunyan from 'bunyan'

const loggerNames = [
  'serverLogger',
  'xhrLogger',
  'apiLogger',
  'functionLogger',
  'bazaarVoiceLogger',
  'bundlesLogger',
  'cnetLogger',
  'vaultLogger',
  'citrus-proxy',
  'citrus-proxy'
]

// Set 'level' in each log to be the string level name instead of integer level (e.g. print "ERROR" instead of 50 as the level for error logs)
// Needed for Elasticsearch indexing in Bosun as other apps are logging 'level' as strings so any logs with 'level' that aren't strings won't appear
const wrappedStdout = () => {
  return {
    write: entry => {
      const logObject = JSON.parse(entry)
      logObject.level = bunyan.nameFromLevel[logObject.level].toUpperCase()
      process.stdout.write(`${JSON.stringify(logObject)}\n`)
    }
  }
}

const Logger = (() => {
  let instance

  function init() {
    return {
      loggers: {},

      debug(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).debug(responseData, msg)
        }
      },

      info(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).info(responseData, msg)
        }
      },

      warn(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).warn(responseData, msg)
        }
      },

      trace(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).trace(responseData, msg)
        }
      },

      fatal(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).fatal(responseData, msg)
        }
      },

      error(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).error(responseData, msg)
        }
      },

      createLoggerInstance(name) {
        return bunyan.createLogger({
          name,
          stream: wrappedStdout(),
          level: Number.parseInt(process.env.LOG_LEVEL, 10) || 40,
          // "serializer" functions to produce a JSON-able object from a JavaScript object
          serializers: { err: bunyan?.stdSerializers?.err }
        })
      },

      getLoggerInstance(name) {
        if (!this.loggers[name]) {
          this.loggers[name] = this.createLoggerInstance(name)
        }

        return this.loggers[name]
      },

      getAllLoggers() {
        return Object.values(this.loggers)
      },

      setupLoggers(nameList) {
        nameList.forEach(name => {
          this.loggers[name] = this.createLoggerInstance(name)
        })
      }
    }
  }

  return {
    getInstance: () => {
      if (!instance) {
        instance = init()
        instance.setupLoggers(loggerNames)
      }
      return instance
    }
  }
})()

export default Logger
